import React from 'react';
import { Box, ButtonGroup } from '@chakra-ui/react';
import LinkButton from '../../../components/custom/LinkButton';
import AddBranchForm from '../../../components/forms/branch/AddBranchForm';
import PageHeader from '../../../components/common/PageHeader';

export default function AddBranch() {
    return (
        <>
            <div className='admin-page-header'>
                <PageHeader headerTitle={'支社登録'} />
                <ButtonGroup gap={2}>
                    <LinkButton buttonText={'戻る'} buttonUrl={'/branches'}/>
                </ButtonGroup>
            </div>
            <Box className='admin-box'>
                <AddBranchForm />
            </Box>
        </>   
    ) 
}
